import React from "react";
import avatar from "../../../assets/img/avatar.svg";
import CircleImage from "../../Image/CircleImage";

export function WidgetsTitledCards(props) {
  return (
    <div
      className={`card col-12 col-lg py-3 ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <span className="title fz-16 ff-univanova-600 text-cl-black px-3">{props.title}</span>
      <div className="dashboard-scroll px-3">{props.children}</div>
    </div>
  );
}

export function WidgetsUserReservationInfos(props) {
  // console.log(props);
  return (
    <div className="d-flex mt-3 ">
      <div className="d-block">
        <CircleImage
          url={props.avatar !== undefined ? (props.avatar !== "" ? props.avatar : avatar) : avatar}
          sizePx={"40px"}
          className={"c-pointer"}
        />
      </div>
      <div className="d-flex justify-content-between w-100 ">
        <div className=" d-flex flex-column justify-content-center">
          <span className="text-cl-black-2 ff-univanova fz-12">{props.title}</span>
          <span className="text-cl-arsenic ff-univanova fz-10">{props.description}</span>
        </div>
        <div className="d-flex justify-content-end align-items-end pb-1">
          <a href={props.link} className="link ff-univanova fz-12">
            {props.linkText}
          </a>
        </div>
      </div>
    </div>
  );
}

export function WidgetsProductsInfo(props) {
  return (
    <div className="mt-3">
      <span className="d-block ff-univanova-medium fz-14 text-cl-black-2">{props.title}</span>
      <div className="d-flex justify-content-between">
        <span className="text-cl-black-2 ff-univanova fz-12">
          {props.descriptionLeft}
          <span className={props.leftValueColor}>{`R$ ${props.leftValue}`}</span>
        </span>
        <span className="text-cl-black-2 ff-univanova fz-12 ">
          {props.rightValue}
          <span className="ms-1">{props.descriptionRight}</span>
        </span>
      </div>
    </div>
  );
}
